<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-button type="primary" @click="show_add"> 新增 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table :data-source="lis" bordered :pagination="false" :scroll="{ y: scroll_y }">
        <a-table-column key="question" width="30%" title="问" data-index="question" />
        <a-table-column key="answer" title="答" data-index="answer" />
        <a-table-column title="操作" width="150px" key="action">
          <template slot-scope="text, record">
            <a-button size="small" type="primary" @click="edit(record)"> 编辑 </a-button>
            <a-button size="small" type="danger" @click="del(record)"> 删除 </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <!-- 新增编辑 -->
    <a-modal :title="is" width="50%" :visible="is_show" @ok="handleOk" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="info" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="question" label="问" prop="question">
          <a-textarea v-model="info.question" placeholder="请输入问题描述" :auto-size="{ minRows: 2, maxRows: 6 }" />
        </a-form-model-item>
        <a-form-model-item ref="answer" label="答" prop="answer">
          <a-textarea v-model="info.answer" placeholder="请输入问题回答" :auto-size="{ minRows: 2, maxRows: 8 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { hot_get_list, hot_add, hot_update, hot_del } from '@/api/system'
export default {
  data() {
    return {
      lis: [],
      scroll_y: 150,
      is_show: false,
      is: '',
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      rules: {
        question: [{ required: true, message: '请输入问题描述', trigger: 'blur' }],
        answer: [{ required: true, message: '请输入问题回答', trigger: 'blur' }],
      },
      info: {
        id: undefined,
        question: '',
        answer: '',
      },
    }
  },
  mounted() {
    this.get_lis()
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height()
        console.log(this.scroll_y)
      }, 1000)
    })
  },
  methods: {
    //获取列表
    get_lis() {
      hot_get_list().then((res) => {
        this.lis = res.data
      })
    },
    //弹出框
    show_add() {
      this.is = '新增'
      this.info = {
        id: undefined,
        question: '',
        answer: '',
      }
      this.is_show = true
    },
    //取消新增
    handleCancel() {
      this.is_show = false
    },
    //点击编辑
    edit(row) {
      this.info = {
        id: row._id,
        question: row.question,
        answer: row.answer,
      }
      this.is = '修改'
      this.is_show = true
    },
    // 提交
    handleOk() {
      var _this = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.is == '新增') {
            hot_add({
              data: {
                question: _this.info.question,
                answer: _this.info.answer,
              },
            }).then((res) => {
              if (res.code != 200) {
                this.$message.error(res.msg)
                return
              }
              this.$message.success('保存成功')
              this.handleCancel()
              this.get_lis()
            })
          } else {
            hot_update({
              _id: this.info.id,
              data: {
                question: _this.info.question,
                answer: _this.info.answer,
              },
            }).then((res) => {
              if (res.code != 200) {
                this.$message.error(res.msg)
                return
              }
              this.$message.success('保存成功')
              this.handleCancel()
              this.get_lis()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //删除
    del(row) {
      var _this = this
      this.$confirm({
        title: '确认删除此记录吗?',
        onOk() {
          hot_del({
            _id: row._id,
          }).then((res) => {
            if (res.code != 200) {
              _this.$message.error(res.msg)
              return
            }
            _this.$message.success('删除成功')
            _this.get_lis()
          })
        },
        onCancel() {
          console.log('Cancel')
        },
        class: 'test',
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>
